import { createEntityAdapter } from "@reduxjs/toolkit"
import { createAppSlice } from "../../app/createAppSlice"

//entity: {  id: targetFoi,  for EvidenceVariable
//  title: string,
// code: CodeableConcept for summary-of-findings-entry-for-a-single-outcome
// focus: Reference to EvidenceVariable,
// section: array 0-7 or 0-8
// itemChanged: boolean
// 
//key uses: Summary of Findings

const summaryOfFindingsAdapter = createEntityAdapter({
    sortComparer: (b, a) => {
        if (b?.targetFoi && a?.targetFoi && b.targetFoi !== a.targetFoi) {
            return b.targetFoi.localeCompare(a.targetFoi)
        } else {
            return 0
        }
    }
})

const initialState = summaryOfFindingsAdapter.getInitialState({
    status: 'idle'
})

const summaryOfFindingsSlice = createAppSlice({
    name: "summaryOfFindings",
    initialState,
    reducers: create => ({
        summaryOfFindingsAdded: create.preparedReducer(
            (findingsBody) => {
                return {
                    payload: {
                        id: findingsBody.id,
                        title: findingsBody.title,
                        code: findingsBody.code,
                        focus: findingsBody.focus,
                        section: findingsBody.section,
                        itemChanged: findingsBody.itemChanged
                    }
                };
            },
            summaryOfFindingsAdapter.addOne
        ),
        summaryOfFindingsUpdated: create.reducer((state, action) => {
            const { id, title, code, focus, section, itemChanged } = action.payload;
            summaryOfFindingsAdapter.updateOne(state,
                {
                    id, changes: {
                        title, code, focus, section, itemChanged
                    }
                })
        }),
        loadSummaryOfFindings: create.reducer((state, action) => {
            summaryOfFindingsAdapter.setAll(state, action.payload.summaryOfFindings);
            state.status = "succeeded";
        })
    }),
    selectors: {
        selectSummaryOfFindingsStatus: summaryOfFindings => summaryOfFindings.status
    }
})

export const { summaryOfFindingsAdded, summaryOfFindingsUpdated, loadSummaryOfFindings } = summaryOfFindingsSlice.actions

export const { selectSummaryOfFindingsStatus } = summaryOfFindingsSlice.selectors

export const {
    selectAll: selectAllSummaryOfFindings,
    selectById: selectSummaryOfFindingsByTargetId,
} = summaryOfFindingsAdapter.getSelectors(state => state.summaryOfFindings)

export default summaryOfFindingsSlice